module.exports = __webpack_public_path__ + "img/17yu.6c94fbce.png";